import { call, put } from 'redux-saga/effects'
import { prerenderMarkLoaded } from 'shared/mechanics/prerender';
import { EtfBackendViewModel } from '../model/backend';

import {SET_DATA_SOURCES, SET_ETFS} from '../model/redux-actions';
import { EtfService } from '../services/etf';

export function* initializeSaga() {
	const etfs: EtfBackendViewModel[] = yield call(EtfService.fetchData);

	yield put(SET_ETFS(etfs));
	yield put(SET_DATA_SOURCES(etfs));

	prerenderMarkLoaded();
}